import { CommonOperationTaxes } from '../operation-taxes'

export const UnitedStatesOperationTaxes = {
  ...CommonOperationTaxes,
} as const
